import { SetLoader } from '../../redux/actions/loader'
import { GET, POST } from '../API'
import { store } from '../../redux/store'
import { AddCustomerGroupList } from '../../redux/actions/devices'
import { GetCreationTemplate } from '../configuration-template'
import { CreateXlsx } from '../xlsx'
const { dispatch } = store

const DEVICE_STATUS_ENUM = {
  CONNECTED: 'CONNECTED',
  CONFIGURED: 'CONFIGURED',
  INSTALLED: 'INSTALLED',
  OFFLINE: 'OFFLINE',
  REGISTERED: 'REGISTERED',
  PROVISIONED: 'PROVISIONED',
  ACTIVE: 'ACTIVE',
  ALL: 'ALL',
  FREE: 'FREE',
}
const GetUserDevices = async (userEmail, productName, status) => {
  const queryParams = {
    product: productName,
    status,
  }
  dispatch(SetLoader(true))

  const response = await GET(
    `/spectro/devices/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))

  if (response.success) {
    return response.data
  }
  return []
}

const CreateDevice = async (userEmail, productName, device, groupList) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }

  const filteredGroupList = groupList.filter(
    (group) => group.id === device.groupId,
  )

  const body = {
    'asset name': device.assetName,
    description: device.description,
    group: {
      id: filteredGroupList[0].id,
      name: filteredGroupList[0].name,
      type: filteredGroupList[0].type,
    },
    'geo location': device.latLng,
    country: device.countryName,
    city: device.cityName,
    address: device.address,
    facility: device.facilityName,
  }

  const response = await POST(
    `/spectro/devices/${userEmail}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))
  return response
}

const GetCustomerGroupList = async (userEmail, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(
    `/spectro/assets/customer/${userEmail}`,
    queryParams,
  )
  dispatch(SetLoader(false))
  if (response.success) {
    dispatch(AddCustomerGroupList(response.data))
  } else {
    // throw new Error(response.msg)
  }
}

const GetDeviceInfo = async (deviceID, productName) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const response = await GET(`/spectro/devices/${deviceID}`, queryParams)
  dispatch(SetLoader(false))
  if (response.success) {
    return response.data
  }
  return {}
}

const ProvisionDevice = async (productName, userEmail, device) => {
  dispatch(SetLoader(true))
  const queryParams = {
    product: productName,
  }
  const body = {
    'device id': device.id,
    email: userEmail,
  }
  console.log('provision', body)

  const response = await POST(
    `/spectro/provision-device/${device.name}`,
    queryParams,
    body,
  )
  dispatch(SetLoader(false))

  return response
}

const CreateDeviceCreateTemplateXlsx = async (
  productName,
  deviceType,
  translate,
) => {
  console.log(productName)

  try {
    await GetCreationTemplate(productName, 'spectro-cold').then((data) => {
      console.log('dat', data)
      data.creationMap.sort((config1, config2) => {
        if (config1.sort < config2.sort) {
          return -1
        }
        if (config1.sort > config2.sort) {
          return 1
        }
        // a must be equal to b
        return 0
      })

      const xlsxHeaders = []
      data.creationMap.forEach((columnData) => {
        console.log('headers', columnData)
        columnData.data.forEach((rowData) => {
          xlsxHeaders.push(translate(rowData['label ID']))
        })
      })
      CreateXlsx('Cold_Device_Template_2', xlsxHeaders, [])
    })
  } catch (e) {
    console.log(e)
  }
}

const GetFacilityDevices = async (queryParams) => {
  const res = await GET('/spectro/devices/facility', queryParams)
  return res
}

const GetColdDeviceAttributes = async (queryParams) => {
  const res = await GET('/spectro/devices/attribute', queryParams)
  return res
}

export {
  GetUserDevices,
  CreateDevice,
  GetCustomerGroupList,
  GetDeviceInfo,
  ProvisionDevice,
  CreateDeviceCreateTemplateXlsx,
  GetFacilityDevices,
  GetColdDeviceAttributes,
  DEVICE_STATUS_ENUM,
}
